// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1653":"d85509569562a23b","2024":"3793ec5044ccda62","4456":"c92d3b743144863b","5660":"5bd7653ac485632f","7915":"a8a4352471414b9a"}[chunkId] + ".css";
};